import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@services/login.service';
import { QbService } from '@services/qb.service';
import { SettingsService } from '@services/settings.service';
import { catchError, filter, switchMap, takeWhile } from 'rxjs';
import { ToastService } from '../../services';

@Component({
  selector: 'app-confirm-email-change',
  templateUrl: './confirm-email-change.component.html',
  styleUrls: ['./confirm-email-change.component.scss'],
})
export class ConfirmEmailChangeComponent implements OnInit, OnDestroy {
  componentActive = true;
  success = undefined;
  newEmail;
  alreadyConfirmed = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private settings: SettingsService,
    private qb: QbService,
    private toast: ToastService,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.loginService.checkAuth$
      .pipe(
        filter((val: boolean) => {
          if (!val) {
            this.loginService.login();
          }
          return val;
        }),
        takeWhile(() => {
          return this.componentActive;
        }),
        switchMap(() => {
          this.qb.loading = true;
          return this.route.params;
        }),
        switchMap(val => {
          if (val['confirmationKey'] == undefined) {
            this.router.navigate(['/']);
            throw new Error('Missing confirmation key');
          }
          return this.settings.confirmEmailChange(val['confirmationKey']);
        }),
        catchError(err => {
          this.success = false;
          this.qb.loading = false;
          if (err.status === 404) {
            this.alreadyConfirmed = true;
          }
          throw new Error(err.error);
        })
      )
      .subscribe({
        next: val => {
          this.newEmail = val;
          this.success = true;
          this.qb.loading = false;
          setTimeout(() => {
            this.loginService.logOut('/', 'Email Address Changed!');
          }, 5000);
        },
        error: error => {
          this.toast.error(error);
          this.success = false;
          this.qb.loading = false;
        },
      });
  }

  ngOnDestroy() {
    this.componentActive = false;
  }
}
